module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/algoliasearch/src/clone.js
// module id = 161
// module chunks = 20 21 22 23 24 25 26 27 28